
<script>

import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['dataseries', 'labels'],
  data () {
    return {
      options: {
        legend: {
          display: false,
          position: 'right',
          labels: {
            fontFamily: 'Roboto Condensed'
          }
        }
      },
      chartData: {
        labels: this.labels,
        datasets: [
          {
            data: this.dataseries,
            backgroundColor: [
              'rgba(99, 255, 132, 0.2)',
              'rgba(235, 99, 54, 0.2)',
              'rgba(255, 210, 0, 0.2)',
              'rgba(0, 78, 255, 0.2)'
            ],
            borderColor: [
              'rgba(99, 255, 132, 1)',
              'rgba(235, 99, 54, 1)',
              'rgba(255, 210, 0, 1)',
              'rgba(0, 78, 255, 1)'
            ]
          }
        ]
      }
    }
  },
  watch: {
    dataseries: function (newVal, oldVal) {
      if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.chartData.datasets[0].data = this.dataseries
        this.renderChart(this.chartData, { ...this.options, animation: false })
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/HealthChart.vue